/* eslint-disable radix */
/* eslint-disable max-len */
import React, { useState, useContext, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import cn from 'classnames';
import { AppContext, AuthContext } from 'Context';
import { Button, Grid, Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Pathname } from 'Routes';
import useSWR from 'swr';
import { axios, dataFetcher, endpoints, baseUrl } from 'Api';
import { logAppEvent } from 'Api/errorLogger';
import { EmailEditModal, PhoneNumberEditModal, PasswordEditModal } from 'Components/edits';
// import PageLayout from 'Pages/public/landing/plans/CheckoutForm/components/page-layout';
import { Page, Header } from 'Components';
import { WarningPopup } from 'Components/WarningPopup';
import { PLANS } from 'Commons';
import styles from './index.module.css';
import { DataView } from '../components/data-view';
import { SettingsPage } from '../components/page';

export const BillingSettings = () => {
  const { userDetails, allPlans, subscriptionDetails, setAppSnackbar, getSubscription, langText, isTrail, autoSignIn, warningTitle, warningMessage, userAccessedData } = useContext(AppContext);
  const { isInActiveUser, gettingSubscription, getToken } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const billPayment = langText?.settings?.billPayment;
  const commonText = langText?.common;
  const accountText = langText?.settings?.account;
  const cancellationText = billPayment?.cancellation;
  const [emailEditModalIsVisible, setEmailEditModalVisibility] = useState(false);
  const [phoneNumberEditModalIsVisible, setPhoneNumberEditModalVisibility] = useState(false);
  const [passwordEditModalIsVisible, setPasswordEditModalVisibility] = useState(false);
  const [warningPopup, setWarningPopup] = useState(false);
  const [isCancelClicked, setIsCancelClicked] = useState(false);
  const [renewModalOpen, setRenewModalOpen] = useState(false);
  const [reactivating, setReactivating] = useState(false);
  const defaultSnackbar = { isVisible: false, type: undefined, message: undefined };
  const [snackbar, setSnackbar] = useState(defaultSnackbar);
  console.log('subscriptionDetails', subscriptionDetails);
  const isPaidPlan = (!!subscriptionDetails?.subscription
    && subscriptionDetails?.subscription?.id !== '6')
    || subscriptionDetails?.expired;

  const revealEmailEditModal = () => {
    if (userDetails?.isLoginUsingSocial) {
      setWarningPopup(true);
    } else {
      setEmailEditModalVisibility(true);
    }
  };
  const hideEmailEditModal = () => { setEmailEditModalVisibility(false); };
  const revealPhoneNumberEditModal = () => { navigate(Pathname.authentication.mobileVerification); };
  const hidePhoneNumberEditModal = () => { setPhoneNumberEditModalVisibility(false); };
  const revealPasswordEditModal = () => { setPasswordEditModalVisibility(true); };
  const hidePasswordEditModal = () => { setPasswordEditModalVisibility(false); };
  const [cardDetails, setCardDetails] = useState({ barnd: undefined, last4: undefined, lastAttempt: undefined, month: undefined, year: undefined });
  const planName = subscriptionDetails?.subscription?.product_name;
  const planId = Array.isArray(subscriptionDetails?.plans) && subscriptionDetails.plans.length > 0
    ? subscriptionDetails.plans[subscriptionDetails.plans.length - 1]?.plan_id
    : subscriptionDetails?.plans;

  const planOption = subscriptionDetails?.action;
  const subscription_id = subscriptionDetails?.subscription?.id;
  const status = subscriptionDetails?.has_activePlan;
  const purchaseId = subscriptionDetails?.subscription?.purchase_plan_id;
  const freePlan = parseInt(subscriptionDetails?.subscription?.plan_type, 10) === 3;
  const paymentProcessing = parseInt(subscriptionDetails?.subscription?.subscription_status, 10) === 4 && subscriptionDetails?.has_activePlan;
  const paymentRetry = parseInt(subscriptionDetails?.subscription?.subscription_status, 10) === 2 && subscriptionDetails?.has_activePlan;
  useEffect(() => {
    const paymentMethods = subscriptionDetails?.paymentMethods;
    const defaultPaymentMethod = subscriptionDetails?.default_payment_methods;
    if (paymentMethods && defaultPaymentMethod) {
      const paymentMethod = paymentMethods.find(({ id }) => id === defaultPaymentMethod);
      const brand = paymentMethod?.card?.brand;
      const last4 = paymentMethod?.card?.last4;
      const month = paymentMethod?.card?.exp_month;
      const year = paymentMethod?.card?.exp_year;
      const lastAttempt = paymentMethod?.last_attempt;
      setCardDetails({ brand, last4, lastAttempt, month, year });
    }
  }, [subscriptionDetails]);

  const [done, setDone] = useState(true);
  const handleCancellation = () => {
    navigate(Pathname.cancelSubscription);
  };
  const [openCencellationModal, setOpenCencellationModal] = React.useState(location.search?.includes(Pathname.cancelSubscription));
  useEffect(() => {
    if (location.search?.includes(Pathname.cancelSubscription)) {
      setOpenCencellationModal(true);
      // alert('Pathname.cancelSubscription');
    } else {
      setOpenCencellationModal(false);
    }
  }, [location]);
  const endDateOfSub = subscriptionDetails?.end_date ? new Date(subscriptionDetails.end_date) : null;

  let formattedDate = null;
  if (endDateOfSub && !Number.isNaN(endDateOfSub)) {
    endDateOfSub.setDate(endDateOfSub.getDate() - 1);
    const day = String(endDateOfSub.getDate()).padStart(2, '0');
    const month = endDateOfSub.toLocaleString('en-US', { month: 'long' });
    const year = endDateOfSub.getFullYear();

    formattedDate = `${month} ${day}, ${year}`;
  }
  const { isValidating: cancellingSubscription, mutate: cancelSubscription } = useSWR([endpoints.cancelSubscription, { plan_id: purchaseId }], {
    fetcher: (url, purchaseId) => dataFetcher(url, purchaseId),
    onSuccess: ({ success, data }) => {
      if (success) {
        getSubscription();
        setDone(false);
        setAppSnackbar({
          isVisible: true,
          type: 'success',
          message: 'Membership removed',
        });
        navigate(Pathname.dashboard);
      } else {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Oops! Something went wrong while canceling',
        });
      }
    },
    onError: () => {
      setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong' });
    },
  });

  const { isValidating: paymentRetrying, mutate: retryPayment } = useSWR([
    endpoints.retryPayment, purchaseId], {
    fetcher: (url, subscription_id) => dataFetcher(url, { subscription_id }),
    onSuccess: ({ success, message }) => {
      if (success) {
        setAppSnackbar({
          isVisible: true,
          type: 'success',
          message,
        });
        setTimeout(() => {
          window.location.replace(Pathname.dashboard);
        }, 3000);
      } else {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message,
        });
      }
    },
    onError: (error) => {
      const responseData = error?.response?.data?.message;
      setAppSnackbar({ isVisible: true, type: 'error', message: (responseData || 'Oops! Something went wrong.') });
    },
  });

  const [isDisabled, setIsDisabled] = useState({ isDisabled: true, error: 'You are not allowed to cancel subscription at this time' });

  const [trial_end, setTrial_end] = useState({ year: undefined, month: undefined, day: undefined });
  const [today, setToday] = useState({ year: undefined, month: undefined, day: undefined });
  useEffect(() => {
    if (subscriptionDetails?.subscription?.end_date) {
      const date = subscriptionDetails?.subscription?.end_date?.split(' ')[0].split('-');
      const time = subscriptionDetails?.subscription?.end_date?.split(' ')[1].split(':');
      const d = new Date();
      const year = parseInt(date[0]);
      const month = parseInt(date[1]);
      const day = parseInt(date[2]);
      const todaysDate = { year: d.getFullYear(), month: d.getMonth(), day: d.getDate(), time: d.getTime() };
      setTrial_end({ year, month, day, time });
      setToday(todaysDate);
      if (todaysDate.year > year) {
        setIsDisabled({ ...isDisabled, isDisabled: false });
      } else if (todaysDate.month > month) {
        setIsDisabled({ ...isDisabled, isDisabled: false });
      } else if (todaysDate.month === month && todaysDate.day > day) {
        setIsDisabled({ ...isDisabled, isDisabled: false });
      } else {
        setIsDisabled({ ...isDisabled, isDisabled: true });
      }
    }
  }, [subscriptionDetails]);
  useEffect(() => {
  }, [today, trial_end]);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const autorenew = params.get('autorenew');
    if (autorenew === 'yes') {
      setRenewModalOpen(true);
    }
  }, [today, trial_end]);

  const handleCancelSubscription = () => {
    // if (!isDisabled.isDisabled) {
    //   cancelSubscription();
    // } else {
    //   setAppSnackbar({ isVisible: true, type: 'error', message: isDisabled.error });
    // }
    setIsCancelClicked(true);
    cancelSubscription();
  };
  const time = '2024-11-26 08:9:10';
  const endDateUTC = new Date(`${subscriptionDetails?.subscription?.end_date}Z`); // Interpret as UTC
  const currentDate = new Date(); // System's local time
  const differenceInMs = endDateUTC - currentDate; // Difference in milliseconds
  const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24)); // Convert to days
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // Months are 0-based
  const isExpired = cardDetails?.year < currentYear
    || (cardDetails?.year === currentYear && cardDetails?.month < currentMonth);

  const [loader, setloader] = useState(false);
  const [cancellingSwitch, setCancellingSwitch] = useState(false);
  const isMoreThan365Days = (endDateOfSub - currentDate) > 3650 * 24 * 60 * 60 * 1000;
  const subscribePlan = async () => {
    setloader(true);
    try {
      const myToken = await getToken();
      const apiUrl = `${baseUrl}/${endpoints.addPlanV2}`;
      const requestBody = {
        token: myToken,
        plan_id: planId,
        is_free: 0,
        upgrade: true,
        trial: false
      };
      const response = await axios.post(apiUrl, requestBody);
      setAppSnackbar({
        isVisible: true,
        type: 'success',
        message: response?.data?.message || 'Plan purchased successfully',
      });
      getSubscription();
      autoSignIn();
      setloader(false);
    } catch (error) {
      getSubscription();
      autoSignIn();
      const responseData = error?.response?.data?.message;
      console.error('error', error);
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'Purchase Plan',
        description: 'Plan purchase failed from billing settings',
        severity: 'high',
        errorMessage: responseData || error?.message || 'Plan purchase failed',
        responseStatus: error?.response?.status || null,
        responseBody: responseData || null,
        requestUrl: `${baseUrl}/${endpoints.addPlanV2}`,
        requestMethod: 'POST',
        component: 'BillingSettings',
        userAction: 'Purchase plan called',
      });
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: responseData || 'Oops! Something went wrong while purchasing plan',
      });
      setloader(false);
    }
  };

  const handleCancelSwitchPlan = async () => {
    setCancellingSwitch(true);
    try {
      const myToken = await getToken();
      const apiUrl = `${baseUrl}/${endpoints.cancelSwitchPlan}`;
      const requestBody = {
        token: myToken,
      };

      const response = await axios.post(apiUrl, requestBody);

      setAppSnackbar({
        isVisible: true,
        type: 'success',
        message: response?.data?.message || 'Switch plan request cancelled successfully',
      });

      getSubscription();
      autoSignIn();
    } catch (error) {
      const responseData = error?.response?.data?.message;
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: responseData || 'Failed to cancel switch plan request',
      });
    } finally {
      setCancellingSwitch(false);
    }
  };

  const reactivateSubscription = async () => {
    setReactivating(true);
    try {
      const myToken = await getToken();
      const apiUrl = `${baseUrl}/${endpoints.reactivateSubscription}`;
      const requestBody = {
        token: myToken,
        plan_id: purchaseId,
      };
      const response = await axios.post(apiUrl, requestBody);
      setAppSnackbar({
        isVisible: true,
        type: 'success',
        message: response?.data?.message || 'Subscription reactivated successfully',
      });
      getSubscription();
      autoSignIn();
      setRenewModalOpen(false);
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (error) {
      const responseData = error?.response?.data?.message;
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: responseData || 'Oops! Something went wrong while reactivating subscription',
      });
    } finally {
      setReactivating(false);
    }
  };

  const Dialouge = () => (
    <>

      <Dialog
        fullScreen
        open={openCencellationModal}
        // onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        {' '}
        {/* <Page
          // className={styles.page}
          // containerClassName={styles.pageContainer}
          // contentClassName={styles.pageContent}
          noBottomBar
          noDefaultBg
          noFixedSidebar
          transparentCompactHeader
        > */}
        <Header
          transparentCompactHeader
          headerTheme
        />
        <div className={styles.theMain}>
          <div className={styles.mainBox}>
            <div className={styles.main_top}>
              <h2 className={styles.main_heading}>
                {subscriptionDetails?.subscription?.is_trial === '0' ? cancellationText?.title || 'Are you done Sharing?' : 'Stop sharing your memories?'}
              </h2>
              <div className={styles.main_subHeading}>
                {cancellationText?.description || 'If you are sure you’d like to cancel your subscription, finish below.'}

              </div>
            </div>
            <div className={styles.main_box}>
              <div className={styles.main_box_list}>
                <ul>
                  {
                    subscriptionDetails?.subscription?.is_trial === '0'
                    && (
                      <li>
                        {'Cancelation will be effective at the end of your current billing period on' || cancellationText?.pointOne}
                        {' '}
                        {`${trial_end.day}/${trial_end.month}/${trial_end.year}`}
                      </li>
                    )
                  }
                  {
                    subscriptionDetails?.subscription?.is_trial !== '0'
                    && (
                      <li>By canceling your trial you will no longer have access to your content.</li>
                    )
                  }
                  <li>{cancellationText?.pointTwo || 'Come back anytime. If you restart within 30 days your profiles, videos, viewers and account details will be waiting for you.'}</li>
                </ul>
              </div>
              <div className={styles.main_box_buttons}>
                <button
                  disabled={cancellingSubscription || !done || isCancelClicked}
                  className={styles.firstButton}
                  style={isCancelClicked ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  onClick={() => handleCancelSubscription()}
                >
                  {isCancelClicked ? 'Canceling' : (cancellingSubscription) ? !done ? 'Canceled' : 'Canceling' : (subscriptionDetails?.subscription?.is_trial === '1' ? 'Finish Trial Cancelation' : 'Finish Cancelation' || cancellationText?.finish)}

                </button>

                <button className={styles.secondButton} disabled={cancellingSubscription || !done || isCancelClicked} onClick={() => navigate(-1)}>{commonText?.goBack || 'Go Back'}</button>
              </div>
            </div>
          </div>
        </div>
        {/* </Page> */}
      </Dialog>
    </>
  );
  return (
    <>
      <SettingsPage
        title={billPayment?.title || 'Billing and Payment'}
        description={
          billPayment?.description
          || 'Edit Payment method, add and remove cards'
        }
      >
        <DataView
          data={[
            {
              labelTitle: (
                <div className={styles.main}>
                  <div className={styles.main_heading}>
                    Subscription & Billing
                  </div>
                  {subscription_id
                    && subscription_id !== undefined
                    && subscriptionDetails?.has_activePlan
                    && !freePlan
                    && !paymentProcessing
                    && subscriptionDetails?.subscription?.is_public !== '0'
                    && subscriptionDetails?.subscription?.is_public !== 0
                    && subscriptionDetails?.current_plan !== 'Lifetime' && (
                      <button
                        onClick={() => (
                          // cardDetails?.lastAttempt?.payment_status === '0' ? setAppSnackbar({
                          //   isVisible: true,
                          //   type: 'error',
                          //   message: cardDetails?.lastAttempt?.failure_reason }):
                          paymentRetry ? retryPayment() : handleCancellation())}
                        className={cn({
                          [styles.main_button]: true,
                          [styles.reActiveButton]: paymentRetry,
                          [styles.disabled]: paymentRetrying || subscriptionDetails?.subscription?.is_cancelled === '1'
                        })}
                        disabled={paymentRetrying || subscriptionDetails?.subscription?.is_cancelled === '1'}
                      >
                        {paymentRetry
                          ? billPayment?.reActivate || 'Reactivate'
                          : subscriptionDetails?.subscription?.is_cancelled === '1'
                            ? 'Subscription Canceled'
                            : subscriptionDetails?.subscription?.is_trial === '1'
                              ? 'Cancel Trial'
                              : 'Cancel Subscription'}
                      </button>
                    )}
                  {subscriptionDetails?.subscription?.is_cancelled === '1'
                    && subscriptionDetails?.subscription?.is_public !== '0'
                    && subscriptionDetails?.subscription?.is_public !== 0
                    && subscriptionDetails?.current_plan !== 'Lifetime' && (
                    <div
                      className={`${styles.renewalPrompt} ${styles.renewLink}`}
                      onClick={() => setRenewModalOpen(true)}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) => e.key === 'Enter' && setRenewModalOpen(true)}
                    >
                      Do you want to restart auto-renewal for your plan?
                    </div>
                  )}
                </div>
              ),
              data: (
                <>
                  <div className={styles.labelLinks_container_main}>
                    <div className={styles.labelLinks_container_sub}>
                      <div
                        className={`${styles.labelLinks} ${styles.firstLabelLink} `}
                      >
                        <div
                          className={`${styles.label} ${styles.firstLabel} `}
                        >
                          {userDetails?.email}
                        </div>
                        {!isInActiveUser && !gettingSubscription ? (
                          <Grid
                            onClick={revealEmailEditModal}
                            className={`${styles.link} ${styles.firstLink} `}
                          >
                            {billPayment?.changeEmail || 'Change account email'}
                          </Grid>
                        ) : null}
                      </div>
                      {!isInActiveUser && !gettingSubscription ? (
                        <div
                          className={`${styles.labelLinks} ${styles.secondLabelLink} `}
                        >
                          <div
                            className={`${styles.label} ${styles.secondLabel} `}
                          >
                            Password
                            {' '}
                            {!userDetails?.no_password ? '********' : '- - - - - - - -'}
                          </div>
                          <Grid
                            onClick={revealPasswordEditModal}
                            className={`${styles.link} ${styles.secondLink} `}
                          >
                            {billPayment?.changePassword || 'Change Password'}
                          </Grid>
                        </div>
                      ) : null}
                      <div
                        className={`${styles.labelLinks} ${styles.secondLabelLink} `}
                      >
                        <div
                          className={`${styles.label} ${styles.secondLabel} `}
                        >
                          {' '}
                          {userDetails?.mobile}
                        </div>
                        {!isInActiveUser && !gettingSubscription ? (
                          <Grid
                            onClick={revealPhoneNumberEditModal}
                            className={`${styles.link} ${styles.firstLink} `}
                          >
                            {userDetails?.mobile
                              ? 'Change phone number'
                              : billPayment?.addPhonenumber
                              || 'Add phone number'}
                          </Grid>
                        ) : null}
                      </div>
                    </div>
                    <div className={styles.labelLinks_container_sub}>
                      <div
                        className={`${styles.labelLinks} ${styles.secondLabelLink} `}
                      >
                        <div
                          className={`${styles.label} ${styles.secondLabel} `}
                        >
                          {cardDetails.brand}
                          {cardDetails.last4 && (
                            <>
                              <span className={`${styles.colorBlack} `}>
                                {' '}
                                ***** ****
                                {' '}
                                {cardDetails.last4}
                                {' '}
                              </span>
                              <div>
                                {isExpired && <p className={styles.expiredx}>Card Expired</p>}
                              </div>
                              {isInActiveUser && cardDetails?.lastAttempt?.payment_status === '0' ? (
                                <>
                                  <span className={styles.redColor}>
                                    {'Update payment method' || billPayment?.updatePaymentMethod}
                                  </span>
                                  <div className={styles.redColorExpired}>
                                    {`(${cardDetails?.lastAttempt?.failure_reason || 'Last payment failed'
                                      })`}

                                  </div>
                                </>
                              ) : null}
                            </>
                          )}
                        </div>
                        <Grid
                          component={Link}
                          to={Pathname.getSettingsPath(
                            Pathname.settings.managePaymentMethods
                          )}
                          className={`${styles.link} ${styles.secondLink} `}
                        >
                          {billPayment?.manageInfo || 'Manage Payment Info'}
                        </Grid>
                      </div>
                    </div>
                    <p className={styles.expired}>
                      {subscriptionDetails?.expired ? 'Your plan has expired, please upgrade' : null}
                    </p>
                  </div>
                </>
              ),
            },
          ]}
        />
        <DataView
          data={[
            {
              labelTitle: (
                <div className={styles.main}>
                  <div className={styles.main_heading}>
                    {billPayment?.planDetails || 'Plan Details'}
                  </div>
                </div>
              ),
              // labelHasAddIcon: true,
              // onLabelClick: () => { alert('click on card to make payment '); },
              data: (
                <>
                  <div
                    style={{ borderTop: 'solid' }}
                    className={styles.labelLinks_container_main}
                  >
                    <div className={styles.labelLinks_container_sub}>
                      <div
                        className={`${styles.labelLinks} ${styles.firstLabelLink} `}
                      >
                        <div
                          className={`${styles.label} ${styles.firstLabel} `}
                        >
                          {subscriptionDetails?.subscription?.is_trial === '1' ? `${subscriptionDetails?.current_plan} (Trial plan)` : !subscriptionDetails?.expired ? userDetails?.isSubscription?.plan || 'Free Plan' : 'Plan Expired'}
                          <Tooltip title={userDetails?.isSubscription && !subscriptionDetails?.expired && subscriptionDetails?.subscription?.is_trial !== '1'
                            ? 'Unlimited uploads and Unlimited storage'
                            : 'Free plan gives you 15 free video upload or 5GB upload'}
                          >
                            <InfoIcon size="large" />
                          </Tooltip>
                        </div>
                        {subscriptionDetails?.subscription?.is_trial === '1' ? (
                          <Grid
                            component={Link}
                            to={userDetails?.isSubscription && !subscriptionDetails?.expired ? '' : Pathname.plans}
                            className={`${styles.link} ${styles.firstLink} ${userDetails?.isSubscription && !subscriptionDetails?.expired && styles.linkDisabled}`}
                          >
                            {subscriptionDetails?.subscription?.is_trial === '1' && (
                              <div
                                onKeyPress={undefined}
                                role="button"
                                tabIndex={0}
                                disabled={loader}
                                onClick={subscribePlan}
                                style={{
                                  cursor: loader ? 'not-allowed' : 'pointer',
                                  pointerEvents: loader ? 'none' : 'auto', // Disable interaction
                                  opacity: loader ? 0.6 : 1, // Dim to indicate disabled state
                                }}
                                className={styles.itsAlink}
                              >
                                {loader ? 'Upgrading' : `Upgrade To ${subscriptionDetails?.current_plan}`}
                              </div>
                            )}
                            {subscriptionDetails?.subscription?.is_trial === '1' ? (
                              <div className={styles.leftico}>
                                {
                                  differenceInDays > 0
                                    ? `Trial ends in ${differenceInDays} ${differenceInDays > 1 ? 'days' : 'day'}`
                                    : 'Trial ends today'
                                }
                                {' '}
                                (10 free uploads)
                              </div>
                            )
                              : formattedDate !== null
                                ? (!subscriptionDetails?.expired ? `Expires on ${formattedDate}` : `Expired on ${formattedDate}`)
                                : null}
                          </Grid>
                        )
                          : (
                            subscriptionDetails?.subscription?.is_cancelled === '1' ? (
                              <div className={styles.leftico} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <span>Plan has been canceled and will expire</span>
                                <span style={{ alignSelf: 'flex-end' }}>
                                  on
                                  {' '}
                                  {formattedDate}
                                </span>
                              </div>
                            ) : (
                              <Grid
                                component={Link}
                                to={userDetails?.isSubscription && !subscriptionDetails?.expired ? '' : (userAccessedData ? '/affiliate' : Pathname.plans)}
                                className={`${styles.link} ${styles.firstLink} ${userDetails?.isSubscription && !subscriptionDetails?.expired && styles.linkDisabled}`}
                              >
                                {userDetails?.isSubscription && !subscriptionDetails?.expired ? 'Upgraded to ' : 'Upgrade to '}
                                {`${/^(free|subscribe|upgrade)$/i.test(subscriptionDetails?.current_plan || '')
                                  ? 'paid'
                                  : subscriptionDetails?.current_plan} plan`}

                              </Grid>
                            )
                          )}
                      </div>
                      <div className={styles.planInfoContainer}>
                        <div
                          className={styles.leftico}
                        >
                          {
                            subscriptionDetails?.switch_plan_request !== null
                              ? `Plan upgrades to ${subscriptionDetails?.switch_plan_request?.new_plan_name} on ${formattedDate}`
                              : subscriptionDetails?.subscription?.is_cancelled !== '1'
                                && !isMoreThan365Days
                                && (subscriptionDetails?.subscription?.is_trial === '1' ? (
                                  formattedDate
                                ) : formattedDate !== null && cardDetails?.lastAttempt?.payment_status !== '0'
                                  ? (!subscriptionDetails?.expired ? `Plan renews on ${formattedDate}` : `Plan expired on ${formattedDate}`)
                                  : null)
                          }
                        </div>
                        {isPaidPlan && subscriptionDetails?.subscription?.is_cancelled !== '1' && subscriptionDetails?.switch_plan_request === null
                          // && subscriptionDetails?.subscription?.is_public !== '0'
                          // && subscriptionDetails?.subscription?.is_public !== 0
                          && subscriptionDetails?.current_plan !== 'Lifetime'
                          && subscription_id !== '13'
                          && !subscriptionDetails?.expired
                          && (
                            <button onClick={() => navigate('/switchplan')} className={styles.switchPlan}>
                              Switch Plan
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              ),
            },
          ]}
        />
      </SettingsPage>
      <EmailEditModal
        isVisible={emailEditModalIsVisible}
        onHide={hideEmailEditModal}
        title={
          accountText?.updateEmail ? accountText?.updateEmail : 'Update Email'
        }
        subtitle="We have sent the reset code to your existing email."
        resetCodeLabel={
          accountText?.enterResetCode
            ? accountText?.enterResetCode
            : 'Enter reset code'
        }
        newEmailLabel={
          accountText?.enterNewEmail
            ? accountText?.enterNewEmail
            : 'Enter New Email'
        }
      />
      <PhoneNumberEditModal
        isVisible={phoneNumberEditModalIsVisible}
        onHide={hidePhoneNumberEditModal}
        title={
          accountText?.updatepPhoneNumber
            ? accountText?.updatepPhoneNumber
            : 'Update Phone number'
        }
        phoneNumerLabel={
          accountText?.enterPhoneNumber
            ? accountText?.enterPhoneNumber
            : 'Enter Phone number'
        }
      />
      <PasswordEditModal
        isVisible={passwordEditModalIsVisible}
        onHide={hidePasswordEditModal}
        subtitle="We have sent the reset code to your existing email."
        title={
          accountText?.updatePassword
            ? accountText?.updatePassword
            : 'Update Password'
        }
        currentPasswordLabel="Enter reset code"
        newPasswordLabel={accountText?.enterNewPassword || 'Enter new password'}
        passwordRule={
          accountText?.passwordDescription
          || 'Use a minimum of 6 characters (case sensitive) with at lease one number and one special character.'
        }
      />

      <WarningPopup
        isVisible={warningPopup}
        onCancel={() => setWarningPopup(false)}
        onContinue={() => {
          setWarningPopup(false);
          setEmailEditModalVisibility(true);
        }}
        title={warningTitle}
        message={warningMessage}
        cancelText="Cancel"
        continueText="Continue"
      />

      {openCencellationModal && Dialouge()}

      <Dialog
        open={renewModalOpen}
        onClose={() => setRenewModalOpen(false)}
        aria-labelledby="renew-subscription-dialog"
        maxWidth="sm"
        fullWidth
      >
        <div className={styles.renewModal}>
          <h2 className={styles.renewModalTitle}>Renew Your Subscription</h2>
          <p className={styles.renewModalContent}>
            We&apos;d love to have you back! Renewing your subscription will restore full access to all features and your saved content.
          </p>
          <p className={styles.renewModalContent}>
            Your subscription will be renewed with your current payment method on file.
          </p>
          <div className={styles.renewModalButtons}>
            <button
              className={styles.renewModalCancelBtn}
              onClick={() => setRenewModalOpen(false)}
            >
              Cancel
            </button>
            <button
              className={styles.renewModalRenewBtn}
              onClick={reactivateSubscription}
              disabled={reactivating}
            >
              {reactivating ? 'Reactivating...' : 'Renew Subscription'}
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
};
